// filepath: /H:/WordSense Projects/Social-casino_frontend/src/app/splash-screen/splash-screen.component.ts
import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-splash-screen',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './splash-screen.component.html',
  styleUrl: './splash-screen.component.scss'
})
export class SplashScreenComponent implements OnInit, OnDestroy {
  // State variables
  progress = 0;
  isVisible = true;
  showWelcome = false;
  
  // Dice Animation State
  currentDiceIndex = 0; 
  
  // Background elements
  circles = [1, 2, 3, 4, 5];
  stars = Array(30).fill(0).map(() => ({
    left: `${Math.random() * 100}%`,
    top: `${Math.random() * 100}%`,
    size: Math.random() * 3 + 1,
    duration: 2000 + Math.random() * 3000
  }));
coins: any[] = [];
fallingItems: any[] = [];

diceDots = [
  { top: '8px', left: '8px' },
  { top: '8px', left: '26px' },
  { top: '26px', left: '8px' },
  { top: '26px', left: '26px' }
];
  private intervalId: any;
  private diceIntervalId: any;
  private totalDuration = 5000; // 5 seconds total

  constructor() { }

  ngOnInit() {
    for (let i = 0; i < 50; i++) {
  // 1. EQUAL DISTRIBUTION: 
  // If index is even, it's a diamond. If odd, it's a coin.
  const isDiamond = i % 2 === 0;
  const type = isDiamond ? 'diamond' : 'coin colorful';

  // 2. DYNAMIC SIZING:
  // We define different min/max ranges based on the type
  let minSize, maxSize;
  if (isDiamond) {
    minSize = 10; // Smaller diamonds
    maxSize = 25;
  } else {
    minSize = 18; // Coins slightly larger on average
    maxSize = 35;
  }

  const finalSize = Math.floor(Math.random() * (maxSize - minSize + 1) + minSize);

  this.fallingItems.push({
    type: type,
    left: Math.random() * 95, // Increased range to cover more screen width
    duration: 4 + Math.random() * 6,
    delay: Math.random() * 8, // Spread them out more over time
    size: finalSize
  });
}

  // for (let i = 0; i < 55; i++) {
  //   let type;
  //   const rand = Math.random();
  //   if (rand < 0.6)
  //     type = 'diamond';
  //   else if (rand < 0.8)
  //     type = 'coin colorful';
  //   this.fallingItems.push({
  //     type: type,
  //     left: Math.random() * 70,
  //     duration: 4 + Math.random() * 4,
  //     delay: Math.random() * 5,
  //     size: 12 + Math.random() * 22
  //   });
  // }
    this.isVisible = true;
    this.startLoading();
    this.startDiceRolling();

    // Forced termination after totalDuration
    setTimeout(() => {
      this.completeSplashScreen();
    }, this.totalDuration);
  }

  private startLoading() {
    this.intervalId = setInterval(() => {
      this.progress += 2;
      if (this.progress >= 100) {
        clearInterval(this.intervalId);
        this.showWelcome = true;
      }
    }, 50); 
  }

private startDiceRolling() {

  this.diceIntervalId = setInterval(() => {

    let nextIndex;

    do {

      nextIndex = Math.floor(Math.random() * 6);

    } while (nextIndex === this.currentDiceIndex);

    this.currentDiceIndex = nextIndex;

  }, 120);

}

  private completeSplashScreen() {
    if (this.intervalId) clearInterval(this.intervalId);
    if (this.diceIntervalId) clearInterval(this.diceIntervalId);
    this.isVisible = false;
  }

  getDots(diceIndex: number): {top: string, left: string}[] {
    // Patterns for 1 through 6
    const patterns: {top: string, left: string}[][] = [
      [{top: '50%', left: '50%'}], // Index 0 (Dice 1)
      [{top: '20%', left: '20%'}, {top: '80%', left: '80%'}], // Index 1 (Dice 2)
      [{top: '20%', left: '20%'}, {top: '50%', left: '50%'}, {top: '80%', left: '80%'}], // Index 2 (Dice 3)
      [{top: '20%', left: '20%'}, {top: '20%', left: '80%'}, {top: '80%', left: '20%'}, {top: '80%', left: '80%'}], // Index 3 (Dice 4)
      [{top: '20%', left: '20%'}, {top: '20%', left: '80%'}, {top: '50%', left: '50%'}, {top: '80%', left: '20%'}, {top: '80%', left: '80%'}], // Index 4 (Dice 5)
      [{top: '20%', left: '20%'}, {top: '20%', left: '80%'}, {top: '50%', left: '20%'}, {top: '50%', left: '80%'}, {top: '80%', left: '20%'}, {top: '80%', left: '80%'}]  // Index 5 (Dice 6)
    ];
    return patterns[diceIndex] || [];
  }

  ngOnDestroy() {
    // Cleanup all intervals to prevent memory leaks
    if (this.intervalId) clearInterval(this.intervalId);
    if (this.diceIntervalId) clearInterval(this.diceIntervalId);
  }
}